import { css } from '@/styled-system/css';

export const container = css({
  display: 'flex',
  flexDirection: 'column',
});

export const priceRow = css({
  display: 'flex',
  alignItems: 'center',
  gap: '1x',
});

export const priceText = css({
  fontSize: 'xl',
  fontWeight: 'bold',
  color: 'hpxBlue600',
});

export const priceSuffix = css({
  fontSize: 'xl',
  fontWeight: 'bold',
  color: 'hpxBlue600',
});

export const detailsRow = css({
  fontSize: 'md',
  color: 'hpxGrey600',
  marginTop: 'xs',
});

export const buildingName = css({
  fontWeight: 'bold',
  fontSize: 'md',
  color: 'hpxGrey600',
  marginTop: '2x',
});

export const addressText = css({
  fontSize: 'md',
  color: 'hpxGrey600',
});

export const addressTriggerRow = css({
  display: 'flex',
  alignItems: 'center',
  gap: '1x',
  marginTop: '2x',
  cursor: 'pointer',
  background: 'none',
  border: 'none',
  padding: 0,
  textAlign: 'left',
});

export const websiteContainer = css({
  marginTop: '1x',
});

export const websiteLink = css({
  display: 'inline-flex',
  alignItems: 'center',
  gap: 'xs',
  fontSize: 'md',
  color: 'hpxTeal500',
  textDecoration: 'none',
  fontWeight: 'bold',

  _hover: {
    textDecoration: 'underline',
    color: 'hpxTeal600',
  },
});

export const externalIcon = css({
  width: '14px',
  height: '14px',
  marginLeft: 'xs',
});
